import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-three-sixty-viewer',
  templateUrl: './three-sixty-viewer.component.html',
  styleUrls: ['./three-sixty-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeSixtyViewerComponent {
  @Input() images: string[] = [];
  @Input() openInModal = false;
  @Input() wrapperElement?: HTMLElement;

  isModalVisible = false;
  modalInitialized = false;

  constructor(private cdr: ChangeDetectorRef) {}

  onModalAfterOpen(): void {
    this.modalInitialized = true;
  }

  openModal(): void {
    this.isModalVisible = true;
    this.cdr.detectChanges();
  }

  closeModal(): void {
    this.isModalVisible = false;
  }
}
